<template lang="html">
<el-select multiple collapse-tags class="inpText" size="medium" @change="selectChange" v-model="id" :placeholder="plaText">
    <el-option v-for="item in selectArr" :key="item.id" :label="item.name" :value="item.id">
    </el-option>
</el-select>
</template>

<script>
import {
    dicSeek
} from "@/api/pgMent/dictMent";
export default {
    model: {
        prop: "selectId", // 父组件设置v-model的变量值，v-model="message"
        event: "selectChange" // 父组件监听message事件
    },
    name: 'allSelect',
    props: ['code', 'selectId', 'paramsKey', 'plaText'],
    watch: {
        selectId: function (e) {
            console.log(e);
            if (e) {
                this.id = e.split(',');

            } else {
                this.id = null;
            }
        }
    },
    data() {
        return {
            id: [],
            selectArr: [],
            dectMap: {}
        }
    },
    methods: {
        selectChange: function (e) {
            console.log(e);
            var vues = this
            var names = [];
            e.forEach(item => {
                names.push(vues.dectMap[item]);
            })
            var data={
                id: e.join(','),
                name: names.join(','),
                paramsKey: this.paramsKey
            };
           
            this.$emit('selectChange', e.join(','));
             this.$emit('change', data);
        }
    },
    created: function () {
        var vues = this;
        console.log(this.selectId);
        if (this.selectId) {
            this.id = vues.selectId.split(',');
        }
        dicSeek({
            code: this.code
        }).then(res => {
            var unFormate = res.dataDictionarys;
            vues.selectArr = unFormate;
            for (var i = 0; i < unFormate.length; i++) {
                vues.dectMap[unFormate[i].id] = unFormate[i].name;
            }
        })
    }

}
</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// dcAllSelect.vue?007a619c